import { push } from "connected-react-router";
import { CreateBase, useCreateContext } from "ra-core";
import React, { FC, useCallback } from "react";
import { useDispatch } from "react-redux";
import { SaveAction } from "@/dataProvider/types";
import { OrganizationProfileInput } from "@/gen/api/user";
import { OdResourcePageProps } from "@/types/resource";
import OrganizationProfileCreateBody from "./CreateBody";


export const OrganizationProfileCreateCater: FC<OdResourcePageProps> = (props) => {
  const { save } = useCreateContext<OrganizationProfileInput>({ redirect: '/dashboard' })
  const dispatch = useDispatch()

  const performSave = useCallback<SaveAction<OrganizationProfileInput>>((record, redirect, callbacks) => {
    const fn = save || (() => {})

    function goDashboard() {
      dispatch(push('/dashboard'))
    }
    
    const onSuccess = (resp: any) => 
      Promise.resolve(callbacks && callbacks.onSuccess && callbacks.onSuccess(resp)).then(goDashboard)

    fn(record, redirect, { ...callbacks, onSuccess })
  }, [save, dispatch])

  return (
    <OrganizationProfileCreateBody save={performSave} {...props} />
  )
}

const OrganizationProfileCreate: FC<OdResourcePageProps> = (props) => {
  // useCreateContext
  return (
    <CreateBase {...props} >
      <OrganizationProfileCreateCater {...props} />
    </CreateBase>
  )
}

export default OrganizationProfileCreate;
